import {Samples} from "src/app/infrastructure/moovement-api/models/samples"

export const nominalValueInfo = 'Water level when water source is full';
export const datumInfo = 'Distance between the sensor head and the bottom of the tank (0 for pressure sensors)';
export const highAlertInfo = 'Water level for which an urgent notification for high water level will be sent';
export const highWarningInfo = 'Water level for which a soft notification for high water level will be sent';
export const lowWarningInfo = 'Water level for which a soft notification for low water level will be sent';
export const lowAlertInfo = 'Water level for which an urgent notification for low water level will be sent';

export const toWaterPointValueColorClass = (lastSample?: Samples.AssetSample<any>) => {
  const alertStatus = lastSample?.alertStatus;
  if (alertStatus === Samples.AlertStatus.LOW_WARNING) {
    return 'color-warning'
  } else if (alertStatus === Samples.AlertStatus.LOW_ALERT) {
    return 'color-danger'
  } else if (alertStatus === Samples.AlertStatus.HIGH_WARNING) {
    return 'color-warning'
  } else if (alertStatus === Samples.AlertStatus.HIGH_ALERT) {
    return 'color-danger'
  } else {
    return 'color-primary-information'
  }
}
